import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden")
      this.resultsTarget.innerHTML = ""
      return
    }

    this.timeout = setTimeout(() => {
      fetch(`/dashboard/search?q=${encodeURIComponent(query)}`, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
        .then(response => response.text())
        .then(html => {
          this.resultsTarget.innerHTML = html
          this.resultsTarget.classList.remove("hidden")
        })
        .catch(() => {
          this.resultsTarget.classList.add("hidden")
        })
    }, 300)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
